/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CatalogInput = {
    title: string;
    /**
     * Optional; derived from the title when empty.
     */
    slug?: string;
    description?: string;
    status?: CatalogInput.status;
};
export namespace CatalogInput {
    export enum status {
        DRAFT = 'draft',
        PUBLISHED = 'published',
    }
}

